import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Checkbox from 'builder/components/Checkbox'
import Shadows from 'builder/styles/shadows'

export const Container = styled.div`
  background-color: ${Colors.White};
  margin: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 24px;
`

export const Content = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const Header = styled.div`
  ${Typography.M};
  ${FontWeights.DemiBold};
  text-align: center;
`

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: 12px;
  width: 100%;
`

export const AvailableDaysCheckbox = styled(Checkbox)`
  input[type='checkbox'] {
    border-color: ${Colors.Neutral30};
    transition: border ease-in 0.2s;

    &:checked {
      border-color: ${Colors.Blue50};
    }
  }
`

export const Option = styled.label<{ checked: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${props => (props.checked ? `8px 15px` : `9px 16px`)};
  border: ${props =>
    props.checked ? `2px solid ${Colors.Blue50}` : `1px solid ${Colors.Neutral15}`};
  background: ${Colors.White};
  border-radius: 8px;
  transition: shadow ease-in 0.3s;
  cursor: pointer;

  &:hover {
    ${Shadows.lightWithBorder.low};

    ${AvailableDaysCheckbox} {
      input[type='checkbox'] {
        border-color: ${Colors.Blue50};
      }
    }
  }
`

export const Service = styled.div`
  color: ${Colors.Neutral90};
`
